var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-login"},[_c('Header'),_c('Bg'),_c('Form'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }